<template>
    <div class="model-box">
        <router-link class="model" :to="linkTo">
            <div class="picture">
                <img :src="model.public_vertical_image_path['small']" :alt="model.name"/>
            </div>
            <div class="name">
                <div class="name-box">
                    {{ model.name }}
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        model: {
            type: Object,
            required: true,
        }
    },
    computed: {
        linkTo(){
            return (this.model.username)
                        ? {name: 'model.username', params: {username: '@'+this.model.username}}
                        : {name: 'model.profile', params: {id: this.model.id}};
        },
    }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.model-box {
    text-align: center;
    margin: 5px;
    position: relative;
    width: 216px; // ratio = 1.777777778
    height: 384px; // ratio = 0.5625
    // background: var(--pallete_degrade_start_color);
    // background: -webkit-linear-gradient(bottom, var(--pallete_degrade_start_color), var(--pallete_degrade_finish_color));
    // background: -moz-linear-gradient(bottom, var(--pallete_degrade_start_color), var(--pallete_degrade_finish_color));
    // background: linear-gradient(to top, var(--pallete_degrade_start_color), var(--pallete_degrade_finish_color));
    background-image: url("/img/backgrounds/model-outstanding.jpg");

    @media(max-width: 768px) {    }
    @media(max-width: 469px) { width: 205px; height: 365px; }
    @media(max-width: 449px) { width: 180px; height: 320px; }
    @media(max-width: 399px) { width: 160px; height: 284px; }
    @media(max-width: 359px) { width: 130px; height: 230px; }
    @media(max-width: 299px) { width: 260px; height: 462px; }

    .picture {
        width: 90%;
        height: calc(97.5% - 35px);
        background-position: top;
        background-repeat: no-repeat;
        background-size: cover;
        transition: all ease-in-out 100ms;
        overflow: hidden;
        margin: 5% auto;
        
        img{
            width: 100%;
        }
    }

    .name {
        margin-inline: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        height: 35px;
        // background: var(--pallete_degrade_start_color);
        text-transform: uppercase;

        @media(max-width: 768px) {}
        @media(max-width: 469px) { font-size: 15px; }
        @media(max-width: 449px) { font-size: 14px; }
        @media(max-width: 399px) { font-size: 13px; }
        @media(max-width: 359px) { font-size: 12px; }
        @media(max-width: 299px) { font-size: 11px; }

        .name-box {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }
}

body.chads {
    .model-box {
        background-image: url("/img/themes/chads/backgrounds/model-outstanding.jpg");
    }
}
</style>
